module.exports = __webpack_public_path__ + "static/media/part2.28dde027.png";